/*
#*===================================================================
#*
#* Licensed Materials - Property of GameTimeFootage Inc.
#*
#* Copyright NextPro 2018. All Rights Reserved.
#*
#*===================================================================
*/

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'environments/environment';
import { HttpHelpersService } from './http-helpers.service';

@Injectable({ providedIn: 'root' })
export class BreakdownService {
  constructor(private httpClient: HttpClient) {}

  addBreakdownRequest(purchaseIds: number[]): Observable<any> {
    return HttpHelpersService.handleGetResponse(
      this.httpClient.post(`${environment.apiHostname}/v1/breakdown-queue/for-purchases`, { purchaseIds })
    );
  }

  addBreakdownRequestByRelated(purchaseIds: number[]): Observable<any> {
    return HttpHelpersService.handleGetResponse(
      this.httpClient.post(`${environment.apiHostname}/v1/breakdown-queue/for-related-purchases`, { purchaseIds })
    );
  }

  getBreakdownQueueByPurchases(purchaseIds: number[]): Observable<any> {
    return HttpHelpersService.handleGetResponse(
      this.httpClient.post(`${environment.apiHostname}/v1/breakdown-queue/by-purchases`, { purchaseIds })
    );
  }
}
